/** Vibecode authoring notes for `conditional` nodes (empty = omit from LLM bundle). */
export const CONDITIONAL_VIBECODE =
  '`conditional`: `whenAll[]` (preferred) or `when`; show `children` when true, optional `elseChildren`. Clauses: `{qid,eq}`, `{qid,in:[...]}`, `{qid,includes}`, `repeatItemEq`, `derived` predicates.';
